'use strict';

import * as paymentActions from '../actions/payment';

var defaultState = {
    promotionCodes: [],
    globalCardError: null,
    globalEventError: null,
    globalDelegatesError: null,
    isShowingBookingSuccess: false,
    delegateToEdit: null,
    bookingValues: {
        attendees: [],
        payment_method: 'invoice'
    },
    event: null,
    openAccordions: ['organisation'],
    isShowingDelegateList: false,
    eLearningCourse: null,
    showProcessingErrorOverlay: false,
    duplicateAttendeeEmail: false,
    countries: [],
    country: null,
    currentCountryId: null,
    isLoadingCountries: false
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case paymentActions.UPDATE_PROCESSING_ERROR_VISIBILITY:
            return {
                ...state,
                showProcessingErrorOverlay: action.show
            }

        case paymentActions.RESET_PAYMENT_PAGE:

            return defaultState;

        case paymentActions.PROMOTION_CODE_ADDED:

            return {
                ...state,
                promotionCodes: state.promotionCodes.concat(action.promoCode)
            };

        case paymentActions.REMOVE_PROMO_CODE:

            const newPromoCodes = state.promotionCodes.filter((promoCode) => {

                return promoCode.code !== action.promoCode.code;
            });

            return {
                ...state,
                promotionCodes: newPromoCodes
            };

        case paymentActions.HIDE_GLOBAL_DELEGATES_ERROR:

            return {
                ...state,
                globalDelegatesError: null
            };

        case paymentActions.SHOW_GLOBAL_DELEGATES_ERROR:

            return {
                ...state,
                globalDelegatesError: action.errorMessage
            };

        case paymentActions.HIDE_GLOBAL_EVENT_ERROR:

            return {
                ...state,
                globalEventError: null
            };

        case paymentActions.SHOW_GLOBAL_EVENT_ERROR:

            return {
                ...state,
                globalEventError: action.errorMessage
            };

        case paymentActions.HIDE_GLOBAL_CARD_ERROR:

            return {
                ...state,
                globalCardError: null
            };

        case paymentActions.SHOW_GLOBAL_CARD_ERROR:

            return {
                ...state,
                globalCardError: action.errorMessage
            };

        case paymentActions.SHOW_BOOKING_SUCCESS:

            return {
                ...state,
                isShowingBookingSuccess: true
            };

        case paymentActions.DELEGATE_EDITED:

            var attendees = state.bookingValues.attendees.concat([]);

            attendees[action.delegate._index] = action.delegate;

            return {
                ...state,
                bookingValues: {
                    ...state.bookingValues,
                    attendees: attendees
                },
                isShowingDelegateList: true,
                delegateToEdit: null
            };

        case paymentActions.DELEGATE_ADDED:

            action.delegate._index = state.bookingValues.attendees.length;

            return {
                ...state,
                bookingValues: {
                    ...state.bookingValues,
                    attendees: state.bookingValues.attendees.concat([action.delegate])
                },
                isShowingDelegateList: true
            };

        case paymentActions.EDIT_DELEGATE:

            return {
                ...state,
                delegateToEdit: action.delegate,
                isShowingDelegateList: false
            };

        case paymentActions.PROCEED_TO_PAYMENT:

            return {
                ...state,
                openAccordions: ['payment']
            };

        case paymentActions.DELEGATE_REMOVED:
            
            const attendees = state.bookingValues.attendees.filter((attendee, index) => {
                
                return index !== action.delegateIndex;
            });

            const indexedAttendees = attendees.map((attendee, index) => {

                return {
                    ...attendee,
                    _index: index
                };
            });

            return {
                ...state,
                bookingValues: {
                    ...state.bookingValues,
                    attendees: indexedAttendees
                },
                isShowingDelegateList: indexedAttendees.length > 0
            };

        case paymentActions.HIDE_DELEGATE_FORM:

            return {
                ...state,
                delegateToEdit: null,
                isShowingDelegateList: true
            };

        case paymentActions.SHOW_NEW_DELEGATE_FORM:

            return {
                ...state,
                isShowingDelegateList: false
            };

        case paymentActions.BACK_TO_ORGANISATION:

            return {
                ...state,
                openAccordions: ['organisation']
            };

        case paymentActions.BACK_TO_DELEGATES:

            return {
                ...state,
                openAccordions: ['delegates']
            };

        case paymentActions.BACK_TO_PAYMENT:

            return {
                ...state,
                openAccordions: ['payment']
            };

        case paymentActions.PROCEED_TO_DELEGATES:

            return {
                ...state,
                openAccordions: ['delegates'],
                bookingValues: {
                    ...state.bookingValues,
                    ...action.formValues
                }
            };

        case paymentActions.PROCEED_TO_CONFIRMATION:

            return {
                ...state,
                openAccordions: ['confirmation'],
                bookingValues: {
                    ...state.bookingValues,
                    ...action.formValues
                }
            };

        case paymentActions.REFRESH_PAYMENT_EVENT:

            return {
                ...state,
                event: action.event
            };

        case paymentActions.REFRESH_PAYMENT_ELEARNING:

            return {
                ...state,
                eLearningCourse: action.eLearningCourse
            };

        case paymentActions.COUNTRY_LIST_REFRESHED:

            return {
                ...state,
                countries: action.countries['countryList'],
                currentCountryId: action.countries['current']
            };

        case paymentActions.SET_BOOKING_COUNTRY:

            return {
                ...state,
                country: action.country
            };

        case paymentActions.IS_LOADING_COUNTRIES:

            return {
                ...state,
                isLoadingCountries: action.isLoading
            };
        case paymentActions.SET_DUPLICATE_ATTENDEE_EMAIL:

            return {
                ...state,
                duplicateAttendeeEmail: action.isDuplicate
            }

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/payment.js